var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n<div class="app-page">\n	<div class="header">\n	</div>\n\n	<div class="page-content" id="page-content">\n		\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/template/page.tmpl
// module id = 25
// module chunks = 0